import { X } from "lucide-react";
import { FaExclamationTriangle, FaSpinner } from "react-icons/fa";

const CommonConfirmationModal = ({
  modalLoader,
  setShowConfirmationModal,
  description,
  onConfirm
}) => {
  return (
    <div className="modal-backdrop modal-backdrop-switch-user-modal">
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog switch-user-modal" role="document">
          <div className="modal-content modal-content-switch-user-modal">

            <div className="modal-body text-white modal-body-switch-user-modal">
              <div className="modal-title-switch-user-modal">
                <div className="modal-icon-switch-user-modal">
                  <FaExclamationTriangle size={28} />
                </div>

                <h4>Are you sure?</h4>

                <button
                  className="btn modal-close-btn-switch-user-modal"
                  onClick={() => setShowConfirmationModal(false)}
                >
                  <X size={20} />
                </button>
              </div>

              <p className="modal-text-switch-user-modal fs-6">
                {description}
              </p>
            </div>

            <div className="modal-footer-switch-user-modal">
              <button
                type="button"
                className="btn btn-danger modal-btn-danger-switch-user-modal"
                onClick={() => setShowConfirmationModal(false)}
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn btn-light modal-btn-switch-user-modal"
                onClick={onConfirm}
                disabled={modalLoader}
              >
                {modalLoader ? <FaSpinner className="fa-spin" /> : "Yes"}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonConfirmationModal